import ReportsFilters from './FiltersPage';

export default ReportsFilters;
